// extracted by mini-css-extract-plugin
export default {"header__button":"HeaderCartButton_header__button__JCx4F","icon":"HeaderCartButton_icon__OJcs2","badge":"HeaderCartButton_badge__bGT5f","bounce":"HeaderCartButton_bounce__oiCIN"};